// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .easycommerce .easycommerce-multiselect-input {
    width: 100% !important;
    font-family: "Inter", sans-serif !important;
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 26px !important;
    color: var(--color-ec-body) !important;
    border: none !important;
    padding: 0 !important;
}
.easycommerce .easycommerce-multiselect-input::placeholder {
    color: var(--color-ec-placeholder) !important;
}
.easycommerce .easycommerce-multiselect-input:focus {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
} */
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Coupons/components/MultiSelect/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;GAiBG","sourcesContent":["/* .easycommerce .easycommerce-multiselect-input {\n    width: 100% !important;\n    font-family: \"Inter\", sans-serif !important;\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    line-height: 26px !important;\n    color: var(--color-ec-body) !important;\n    border: none !important;\n    padding: 0 !important;\n}\n.easycommerce .easycommerce-multiselect-input::placeholder {\n    color: var(--color-ec-placeholder) !important;\n}\n.easycommerce .easycommerce-multiselect-input:focus {\n    border: none !important;\n    box-shadow: none !important;\n    outline: none !important;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
